import { Outlet } from "react-router-dom";
import { useContext, useEffect } from "react";
import { ReportDatabaseContext } from "../../Contexts/ReportDatabaseContext";
import { CurrentUserContext } from "../../Contexts/CurrentUserContext";
import { OrgTreeContext } from "../../Contexts/OrgTreeContext";


export default function ReportsIndex () {
    const reportContext = useContext(ReportDatabaseContext);
    const { setNodesNeeded } = reportContext;
    const orgTree = useContext(OrgTreeContext);
    const userContext = useContext(CurrentUserContext);
    const currentUser = userContext?.currentUser;

    useEffect(() => {
        if (currentUser) {
    
          const currentUserNode: OrgTreeItem = {
            key: currentUser.userId,
            teamId: currentUser.userId,
            teamType: "volunteer",
            label: currentUser.firstName + " " + currentUser.lastName,
            visible: true,
          };
          setNodesNeeded((prevState) => {
            if (!prevState) return [currentUserNode];
            if (prevState.some(team => team.teamId === currentUserNode.teamId)) return prevState;
            return [...prevState, currentUserNode];
          });
        }
      }, [currentUser, orgTree]);

    return(
            <Outlet/>
    )
}